import { toast } from 'react-toastify'

import { DINING_OPTION_BEHAVIORS } from '../../../utils/dining-options'
import { useUpdateEffect } from '../../../utils/use-update-effect'
import { useFlag } from '../../FeatureFlag/FeatureFlag'

/**
 * This hook will show a toast when the delivery cost has changed.
 */
export const useDeliveryToasts = ({ cart }) => {
  const deliveryChargeTotal = cart && cart.order ? cart.order.deliveryChargeTotal : null
  const diningOptionBehavior = cart ? cart.diningOptionBehavior : null
  const deliveryFlag = useFlag('oo-v3-delivery', false)

  useUpdateEffect(() => {
    if (deliveryFlag === true) {
      if (diningOptionBehavior === DINING_OPTION_BEHAVIORS.DELIVERY) {
        toast('Delivery cost updated')
      }
    }
  }, [deliveryFlag, deliveryChargeTotal, diningOptionBehavior])
}
